<template>
    <div id="app" class="text-left">
        <div class="container">
            <Header/>
            <Main/>
        </div>
    </div>
</template>

<script>
    import Header from './components/Header.vue'
    import Main from './components/Main.vue'

    export default {
        name: 'app',
        data: function () {
            return {
                activeTab: 1,
                activeTabSearch: 1,
            }
        },
        components: {
            Header,
            Main
        },
    }

</script>

<style>

</style>
